var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import CatalogObject, { CatalogObjectType } from './catalog-object';
import { CatalogObjectType as CatalogObjectTypeProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import { fragment } from 'ember-data-model-fragments/attributes';
import { alias } from '@ember/object/computed';
let PricingRule = (_dec = attr('string', {
  defaultValue: CatalogObjectType.PRICING_RULE,
  protoEnum: CatalogObjectTypeProto
}), _dec2 = fragment('connect/pricing-rule/data'), _dec3 = alias('pricingRuleData.discountId'), _dec4 = alias('pricingRuleData.matchProductsId'), _dec5 = alias('pricingRuleData.serviceChargeId'), _dec6 = alias('pricingRuleData.serviceChargeTargetScope'), _class = (_class2 = class PricingRule extends CatalogObject {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "pricingRuleData", _descriptor2, this);
    _initializerDefineProperty(this, "discountId", _descriptor3, this);
    _initializerDefineProperty(this, "matchProductsId", _descriptor4, this);
    _initializerDefineProperty(this, "serviceChargeId", _descriptor5, this);
    _initializerDefineProperty(this, "serviceChargeTargetScope", _descriptor6, this);
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/pricing-rule'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "pricingRuleData", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "discountId", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "matchProductsId", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "serviceChargeId", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "serviceChargeTargetScope", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { PricingRule as default };